exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loadingOrders[data-v-057f1355] {\n  background-color: #bbbbbb;\n  opacity: 0.5;\n}\n.order-pagination__select[data-v-057f1355] {\n  background-color: #f2f2f2;\n  border-color: #e1e1e1;\n  text-transform: none;\n}\n@media (min-width: 1024px) {\n.order-pagination__select[data-v-057f1355] {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    background-color: #ffffff;\n}\n}\n", ""]);

// exports
